import { fetchContentApi } from '../../services/content-api'

export const apiFetchVideos = async (
  currentPhoneId,
  preSaleFlag,
  language,
  customer
) => {
  const preSaleURL = preSaleFlag ? '&presales=1' : ''
  return fetchContentApi(
    `/videos?language=${language}&phoneId=${currentPhoneId}` +
      `&customer=${customer}${preSaleURL}`
  )
}



// WEBPACK FOOTER //
// ./src/containers/Videos/services.js